import { OrdersDashboard } from '../../../models';

export const getOrdersDashboard = (data: any): OrdersDashboard => {
  return {
    received: data.received,
    created: data.created
  };
}
